module.exports = __webpack_public_path__ + "static/media/looper.7817ffab.png";